var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('banner-notice',{ref:"bannerNotice",attrs:{"activeBanner":_vm.activeBanner}}),_vm._v(" "),(!_vm.isDesktop && _vm.showFission)?_c('fission-popup',{ref:"fissionPopup",attrs:{"gameName":"payResult","activeBanner":_vm.activeBanner}}):_vm._e(),_vm._v(" "),_c('MobileShare',{ref:"mobileShare"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }